import { PropsWithChildren } from 'react';

import { CoreContext, CoreProviderContext } from './context.provider';

type ProviderProps = PropsWithChildren & CoreProviderContext;

const Provider = ({ children, errorBoundaryConfig }: ProviderProps) => {
  return <CoreContext.Provider value={{ errorBoundaryConfig }}>{children}</CoreContext.Provider>;
};

export { Provider as CoreProvider };
